import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginType:false,
    registerType:null,
    MineActiveLi: 0,  //
    mineData:null,
    access_token:null,
    floatingType:false,
    pageData:null,
  },
  mutations: {
    setfloatingType(state,params){
      state.floatingType = params
    },
    setaccess_token(state,params){
      state.access_token = params
    },
    setMineData(state,params){
      state.mineData = params
    },
    setMineActiveLi(state,params){
      state.MineActiveLi = params
    },
    setLoginType(state,params){
      state.loginType = params
    },
    setRegisterType(state,params){
      state.registerType = params
    },
    savePageData(state,params) {
      state.pageData = params
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState({
    // 只持久化不需要重置的状态
    paths: ['MineActiveLi', 'mineData', 'access_token', 'floatingType', 'pageData']
  })]
})
